import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router/es';
import Select from 'react-select';
import _ from 'lodash';

import { filterSectionTypes } from 'constants/ingredientsSearch';

class IngredientsSearchFilterSection extends Component {
  constructor(props) {
    super();
    this.state = {
      isExpanded: false,
      isCollapseBlocked: false,
      checkBoxesVisibleOptions: props.checkBoxesOptions ? props.checkBoxesOptions.slice(0, props.initiallyVisibleCount) : [],
      radioButtonsVisibleOptions: props.radioButtonsOptions ? props.radioButtonsOptions.slice(0, props.initiallyVisibleCount) : [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const { checkBoxesOptions, radioButtonsOptions, initiallyVisibleCount } = this.props;
    const { checkBoxesOptions: nextCheckBoxesOptions, radioButtonsOptions: nextRadioButtonsOptions } = nextProps;
    if (!_.isEqual(checkBoxesOptions, nextCheckBoxesOptions)) {
      this.setState({
        checkBoxesVisibleOptions: nextCheckBoxesOptions ? nextCheckBoxesOptions.slice(0, initiallyVisibleCount) : [],
        isExpanded: false,
        isCollapseBlocked: false,
      });
    } else if (!_.isEqual(radioButtonsOptions, nextRadioButtonsOptions)) {
      this.setState({
        radioButtonsVisibleOptions: nextRadioButtonsOptions ? nextRadioButtonsOptions.slice(0, initiallyVisibleCount) : [],
        isExpanded: false,
        isCollapseBlocked: false,
      });
    }
  }

  expandSection = (expand, isCheckBoxes, options) => {
    const filterData = expand ? options : options.slice(0, this.props.initiallyVisibleCount);
    if (isCheckBoxes) {
      this.setState({
        checkBoxesVisibleOptions: filterData,
        isExpanded: expand,
      });
    } else {
      this.setState({
        radioButtonsVisibleOptions: filterData,
        isExpanded: expand,
      });
    }
  };

  renderFilterSectionType = () => {
    const { sectionType } = this.props;

    switch (sectionType) {
      case filterSectionTypes.DROP_DOWN:
        return this.renderDropDownSection();
      case filterSectionTypes.CHECK_BOXES:
        return this.renderCheckBoxesSection();
      case filterSectionTypes.RADIO_BUTTONS:
        return this.renderRadioButtonsSection();
      default:
        return null;
    }
  };

  handleClickCheckBoxOption = (itemId, isSelected) => {
    const {
      facetId,
      changeFilterStatus,
      checkBoxesOptions,
      checkBoxesSelectedOptions,
      initiallyVisibleCount,
    } = this.props;

    // block filter section collapsibility
    let selectedOptions;
    if (isSelected) {
      selectedOptions = [...checkBoxesSelectedOptions, itemId];
    } else {
      const index = checkBoxesSelectedOptions.indexOf(itemId);
      selectedOptions = [
        ...checkBoxesSelectedOptions.slice(0, index),
        ...checkBoxesSelectedOptions.slice(index + 1)];
    }

    const selectedOptionsIndexes = [];
    checkBoxesOptions.forEach((option, index) => {
      if (selectedOptions.indexOf(option.id) > -1) {
        selectedOptionsIndexes.push(index);
      }
    });

    const isCollapseBlocked = Math.max(...selectedOptionsIndexes) >= initiallyVisibleCount;
    if (this.state.isCollapseBlocked !== isCollapseBlocked) this.setState({ isCollapseBlocked });

    // dispatch action to change filter
    changeFilterStatus(facetId, itemId, isSelected);
  };

  renderDropDownSection = () => {
    const {
      dropDownOptions,
      dropDownDefaultValue,
      dropDownIsSearchable,
      dropDownClassNamePrefix,
      dropDownOnChange,
    } = this.props;

    return (
      <Select
        defaultValue={ dropDownDefaultValue }
        options={ dropDownOptions }
        isSearchable={ dropDownIsSearchable }
        classNamePrefix={ dropDownClassNamePrefix }
        onChange={ (selectedOption) => dropDownOnChange(selectedOption.value) }
      />
    );
  };

  renderCheckBoxesSection = () => {
    const {
      sectionHeading,
      checkBoxesOptions,
      checkBoxesSelectedOptions,
      initiallyVisibleCount,
    } = this.props;
    const {
      checkBoxesVisibleOptions,
      isExpanded,
      isCollapseBlocked,
    } = this.state;

    return (
      <div>
        {
          checkBoxesVisibleOptions.map((item, index) => {
            const isItemChecked = checkBoxesSelectedOptions.indexOf(item.id) > -1;

            return (
              <div key={ `${ sectionHeading }-${ index }` } className={ 'custom-toggle checkbox' }>
                <input
                  type={ 'checkbox' }
                  id={ `checkbox-${ sectionHeading }-${ index }` }
                  key={ `checkbox-${ sectionHeading }-${ index }` }
                  name={ sectionHeading }
                  value={ item.name }
                  checked={ isItemChecked }
                  onChange={ () => this.handleClickCheckBoxOption(item.id, !isItemChecked) }
                />
                <label htmlFor={ `checkbox-${ sectionHeading }-${ index }` }>{ item.name }</label>
              </div>
            );
          })
        }
        {
          checkBoxesOptions.length > initiallyVisibleCount && !isCollapseBlocked ?
            <Link onClick={ () => this.expandSection(!isExpanded, true, checkBoxesOptions) } className='pointer'>
              { isExpanded ? 'see less' : 'see more' }
            </Link> : null
        }
      </div>
    );
  };

  renderRadioButtonsSection = () => {
    const {
      sectionHeading,
      radioButtonsOptions,
      radioButtonsSelectedOption,
      initiallyVisibleCount,
      facetId,
      changeFilterStatus,
    } = this.props;
    const {
      radioButtonsVisibleOptions,
      isExpanded,
      isCollapseBlocked,
    } = this.state;

    return (
      <div>
        {
          radioButtonsVisibleOptions.map((item, index) => {
            const isItemChecked = item.id === radioButtonsSelectedOption;

            return (
              <div key={ `${ sectionHeading }-${ index }` } className={ 'custom-toggle radio' }>
                <input
                  type={ 'radio' }
                  id={ `radio-${ sectionHeading }-${ index }` }
                  key={ `radio-${ sectionHeading }-${ index }` }
                  name={ sectionHeading }
                  value={ item.name }
                  checked={ isItemChecked }
                  onChange={ () => changeFilterStatus(facetId, item.id, !isItemChecked) }
                />
                <label htmlFor={ `radio-${ sectionHeading }-${ index }` }>{ item.name }</label>
              </div>
            );
          })
        }
        {
          radioButtonsOptions.length > initiallyVisibleCount && !isCollapseBlocked ?
            <Link onClick={ () => this.expandSection(!isExpanded, false, radioButtonsOptions) } className='pointer'>
              { isExpanded ? 'see less' : 'see more' }
            </Link> : null
        }
      </div>
    );
  };

  render() {
    const {
      sectionHeading,
      isCollapsed,
      handleClickCollapse,
    } = this.props;

    return (
      <div>
        <div className={ 'filter-section' }>
          <div className={ 'flex justify-space-between collapsible-filter' }>
            <h5>{ sectionHeading }</h5>
            <i
              className='material-icons'
              onClick={ handleClickCollapse }
            >{ isCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }</i>
          </div>

          <div style={ isCollapsed ? { display: 'none' } : { display: 'block' } }>
            { this.renderFilterSectionType() }
          </div>
        </div>
      </div>
    );
  }
}

IngredientsSearchFilterSection.propTypes = {
  sectionType: PropTypes.string,
  sectionHeading: PropTypes.string,
  isCollapsed: PropTypes.bool,
  handleClickCollapse: PropTypes.func,
  dropDownOptions: PropTypes.array,
  dropDownDefaultValue: PropTypes.object,
  dropDownIsSearchable: PropTypes.bool,
  dropDownClassNamePrefix: PropTypes.string,
  dropDownOnChange: PropTypes.func,
  checkBoxesOptions: PropTypes.array,
  checkBoxesSelectedOptions: PropTypes.array,
  initiallyVisibleCount: PropTypes.number,
  radioButtonsOptions: PropTypes.array,
  radioButtonsSelectedOption: PropTypes.string,
  changeFilterStatus: PropTypes.func,
  facetId: PropTypes.string,
};

export default IngredientsSearchFilterSection;
